import { NumberArrayGen } from '../numberArrayGen';

function range(start: number, end: number): number[] {
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
}

/**
 * Multiplication table for 2.
 * Port of C# Seznam_Nasobilka__2.
 */
export class GenList_Multiplication__2 extends NumberArrayGen {
  constructor() {
    super(range(0, 10), (i) => `${i * 2}`);
  }
}

/**
 * Multiplication table for 3.
 * Port of C# Seznam_Nasobilka__3.
 */
export class GenList_Multiplication__3 extends NumberArrayGen {
  constructor() {
    super(range(0, 10), (i) => `${i * 3}`);
  }
}

/**
 * Multiplication table for 4.
 * Port of C# Seznam_Nasobilka__4.
 */
export class GenList_Multiplication__4 extends NumberArrayGen {
  constructor() {
    super(range(0, 10), (i) => `${i * 4}`);
  }
}

/**
 * Multiplication table for 5.
 * Port of C# Seznam_Nasobilka__5.
 */
export class GenList_Multiplication__5 extends NumberArrayGen {
  constructor() {
    super(range(0, 10), (i) => `${i * 5}`);
  }
}

/**
 * Multiplication table for 6.
 * Port of C# Seznam_Nasobilka__6.
 */
export class GenList_Multiplication__6 extends NumberArrayGen {
  constructor() {
    super(range(0, 10), (i) => `${i * 6}`);
  }
}

/**
 * Multiplication table for 7.
 * Port of C# Seznam_Nasobilka__7.
 */
export class GenList_Multiplication__7 extends NumberArrayGen {
  constructor() {
    super(range(0, 10), (i) => `${i * 7}`);
  }
}

/**
 * Multiplication table for 8.
 * Port of C# Seznam_Nasobilka__8.
 */
export class GenList_Multiplication__8 extends NumberArrayGen {
  constructor() {
    super(range(0, 10), (i) => `${i * 8}`);
  }
}

/**
 * Multiplication table for 9.
 * Port of C# Seznam_Nasobilka__9.
 */
export class GenList_Multiplication__9 extends NumberArrayGen {
  constructor() {
    super(range(0, 10), (i) => `${i * 9}`);
  }
}

/**
 * Multiplication table for 10.
 * Port of C# Seznam_Nasobilka__10.
 */
export class GenList_Multiplication__10 extends NumberArrayGen {
  constructor() {
    super(range(0, 10), (i) => `${i * 10}`);
  }
}
